import '../bundle/js/lazysizes.min'